import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/noimage1.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-5e1cfa99")

_pushScopeId("data-v-5e1cfa99")
const _hoisted_1 = { class: "recipe-top-list-item-info-image" }
const _hoisted_2 = {
  key: 1,
  class: "recipe-top-list-item-info-no-image",
  src: _imports_0
}
const _hoisted_3 = { class: "recipe-top-list-item-summary" }
const _hoisted_4 = { class: "recipe-top-list-item-summary-title-text-view" }
const _hoisted_5 = { class: "recipe-top-list-item-summary-horizontal" }
const _hoisted_6 = { class: "recipe-top-list-item-summary-appliance-category-area" }
const _hoisted_7 = { class: "recipe-top-list-item-summary-appliance-category-label" }
const _hoisted_8 = { class: "recipe-top-list-item-summary-foodIds" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CommonRecipeFoodIds = _resolveComponent("CommonRecipeFoodIds")

  return (_openBlock(), _createBlock("div", {
    class: "recipe-top-list-item",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick(...args)))
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.recipeImageUrl)
        ? (_openBlock(), _createBlock("img", {
            key: 0,
            class: "recipe-top-list-item-info-image-icon",
            src: _ctx.recipeImageUrl
          }, null, 8, ["src"]))
        : (_openBlock(), _createBlock("img", _hoisted_2))
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", {
          class: "recipe-top-list-item-summary-title-text",
          innerHTML: _ctx.getReciptTitle()
        }, null, 8, ["innerHTML"])
      ]),
      _createVNode("div", _hoisted_5, [
        _withDirectives(_createVNode("div", _hoisted_6, [
          (_ctx.getCategoryIcon())
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                class: "recipe-top-list-item-summary-appliance-category-icon",
                src: _ctx.getCategoryIcon()
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.recipeApplianceCategory), 1)
        ], 512), [
          [_vShow, _ctx.isShowCategory()]
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_CommonRecipeFoodIds, { foodIds: _ctx.recipeFoodIds }, null, 8, ["foodIds"])
        ])
      ])
    ])
  ]))
})